export const getMonthlyPaymentOnAPR = (price: number, APR: number, months: number) => {
	const monthlyAPR = APR / 12
	return (price * monthlyAPR * Math.pow(1 + monthlyAPR, months)) / (Math.pow(1 + monthlyAPR, months) - 1)
}
